import script from "./BottomPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomPopup.vue?vue&type=script&setup=true&lang=js"

import "./BottomPopup.vue?vue&type=style&index=0&id=8cab4bf4&lang=css"

const __exports__ = script;

export default __exports__